import { render, staticRenderFns } from "./cloudNote.vue?vue&type=template&id=7ae42ef4&scoped=true&"
import script from "./cloudNote.vue?vue&type=script&lang=js&"
export * from "./cloudNote.vue?vue&type=script&lang=js&"
import style0 from "./cloudNote.vue?vue&type=style&index=0&id=7ae42ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae42ef4",
  null
  
)

component.options.__file = "cloudNote.vue"
export default component.exports